/**
 * The label to display when selected the filter
 */
export const labelAnniEsperienza = {
  anniEsperienza: 'Anni ',
  workerType: 'tipo lavoratore',
};
